import { Injectable } from "@angular/core";

@Injectable()
export class CtmApiLoader {
    constructor() {
    }

    public show(): void {
        $(".api-loading").show();
    }
    public hide(delay:number = 0):void {
        if (delay == 0) {
            $(".api-loading").hide();
        }
        else {
            $(".api-loading").fadeOut(delay);
        }
        
    }

    public isShow(): boolean {
        return $(".api-loading").is(":visible"); 
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/services/api.loader.service.ts